export const UpdateUserInfoUrl = (userID: string): string => `user/update/profile/${userID}`;

export const UpdateUserProfilePicUrl = (userID: string): string => `user/update/profile-pic/${userID}` 

export const CreateBroadCastUrl = (userID?: string): string => `broadcasts/create` 
export const getBroadCastUrl = (broadcastID?: string): string => broadcastID? `broadcasts/get/${broadcastID}` : `broadcasts/get`

